import { cl, CustomElement } from '@/utils';
import dayjs from 'dayjs';
import select from 'dom-select';

export default class Calendar extends CustomElement {
  static component = 'b-calendar';
  input: HTMLInputElement;
  label: HTMLDivElement;
  init() {
    const isSpanish = this.getAttribute('site') === 'es';
    const initialDate = this.getAttribute('date') || null;
    const minDate = this.hasAttribute('min-date');
    const enableTime = this.hasAttribute('time');
    const dateInput = this.hasAttribute('date-input') ? select<HTMLInputElement>(this.getAttribute('date-input')) : null;

    const closestDropdown = this.closest('sl-dropdown');
    if (closestDropdown) {
      this.label = select('[data-el="date-label"]', closestDropdown);
    }

    Promise.all([
      import('flatpickr'),
      import('flatpickr/dist/l10n/es'),
    ]).then(([mod1, mod2]) => {
      if (mod1) {
        const { default: flatpickr } = mod1;
        flatpickr(this, {
          inline: true,
          defaultDate: initialDate && initialDate !== 'now' ? dayjs(initialDate, 'YYYY-MM-DD HH:mm').toDate() : new Date(),
          enableTime,
          minDate: minDate ? new Date() : null,
          locale: isSpanish && mod2.Spanish ? mod2.Spanish : null,
          onChange: (dates) => {
            this.emit('b-change', dates);
            if (this.input) {
              this.input.value = this.setDate(dates);
            }

            if (dateInput) {
              dateInput.value = this.setDate(dates);
            }

            if (this.label && enableTime) {
              this.label.innerText = dayjs(dates[0]).format('MMMM DD YYYY - hh:mm A');
            }
          },
          onReady: (dates) => {
            this.input = document.createElement('input');
            this.input.type = 'hidden';
            this.input.name = this.getAttribute('name') || 'date';
            this.input.value = initialDate;
            // if (dateInput) {
            //   dateInput.value = initialDate;
            // }
            this.appendChild(this.input);
          }
        })
      }
    });
  }

  emit(name: string, detail: any) {
    const event = new CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail,
    });

    return this.dispatchEvent(event);
  }

  setDate(dates: Date[]) {
    return dates.map((date) => {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    }).join('');
  }
}
